/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*/
  document.addEventListener('DOMContentLoaded', function () {
    const productSections = document.querySelectorAll('[data-section-type="product"]');

    productSections.forEach(function (section) {
      const sizeWrapper = Array.from(section.querySelectorAll('.selector-wrapper')).find(function (wrapper) {
        return wrapper.textContent.toLowerCase().includes('size');
      });

      if (!sizeWrapper) return;

      const sizeInputs = sizeWrapper.querySelectorAll('input[type="radio"]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const buttonText = section.querySelector('[data-add-to-cart-text]');
      const errorContainer = section.querySelector('[data-cart-errors-container]');

      if (!sizeInputs.length || !addButton) return;

      function clearSizeSelection() {
        sizeInputs.forEach(function (input) {
          input.checked = false;
          input.removeAttribute('checked');
        });

        sizeWrapper.querySelectorAll('[aria-checked="true"], [aria-selected="true"], [data-selected="true"]').forEach(function (el) {
          el.removeAttribute('aria-checked');
          el.removeAttribute('aria-selected');
          el.removeAttribute('data-selected');
        });

        sizeWrapper.querySelectorAll('[style*="background-color"]').forEach(function (el) {
          if (el.textContent.trim() === '2') {
            el.style.backgroundColor = 'transparent';
            el.style.color = '#001f60';
          }
        });
      }

      function clearError() {
        if (errorContainer) {
          errorContainer.innerHTML = '';
          errorContainer.classList.remove('is-visible');
        }
      }

      clearSizeSelection();
      setTimeout(clearSizeSelection, 100);
      setTimeout(clearSizeSelection, 500);
      setTimeout(clearSizeSelection, 1000);

      addButton.disabled = false;
      addButton.style.backgroundColor = '#001f60';
      addButton.style.borderColor = '#001f60';
      addButton.style.color = '#ffffff';

      if (buttonText) buttonText.textContent = 'Add to Cart';

      addButton.addEventListener('click', function (event) {
        const hasSelectedSize = Array.from(sizeInputs).some(function (input) {
          return input.checked;
        });

        if (!hasSelectedSize) {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (errorContainer) {
            errorContainer.innerHTML = '<div class="errors">Please select a size.</div>';
            errorContainer.classList.add('is-visible');
          }

          return false;
        }
      }, true);

      sizeInputs.forEach(function (input) {
        input.addEventListener('change', clearError);
        input.addEventListener('click', clearError);
      });
    });
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
